import { TextAlignment } from "@readium/navigator";
export const defaultReadingPreferences = {
    fontSize: 1.0,
    fontFamily: null,
    columnCount: null,
    textAlign: null,
    hyphens: true,
    lineHeight: null,
    colors: null,
    enableAccessibilityOptions: false,
    letterSpacing: 0.1,
    wordSpacing: 0.3,
    paragraphSpacing: 2.5,
    fixedColors: null,
    spreads: null,
};
/** Les réglages appliqués à un livre à mise en page fixe : ses couleurs propres à la place de celles du texte. */
export function fixedLayoutPreferences(prefs) {
    return { ...prefs, colors: prefs.fixedColors };
}
const lineHeights = { Small: 1.3, Medium: 1.45, Large: 1.7 };
/** Mêmes valeurs que `ReflowableColors` dans l'app. */
export const readingThemes = {
    Light: { textColor: "#121212", backgroundColor: "#FFFFFF", linkColor: "#0000EE", visitedColor: "#551A8B" },
    Sepia: { textColor: "#121212", backgroundColor: "#FAF4E8", linkColor: "#0000EE", visitedColor: "#551A8B" },
    Dark: { textColor: "#FEFEFE", backgroundColor: "#000000", linkColor: "#63CAFF", visitedColor: "#0099E5" },
};
/** Paliers de taille identiques à `toReflowableWebPreferences` (ReaderViewModel.kt). */
export function fontSizeStep(fontSize) {
    const steps = [
        [0.85, 0.75],
        [0.95, 0.9],
        [1.05, 1.0],
        [1.15, 1.1],
        [1.25, 1.3],
        [1.35, 1.5],
        [1.45, 1.75],
        [1.55, 2.0],
        [1.65, 2.5],
    ];
    for (const [limit, value] of steps) {
        if (fontSize < limit)
            return value;
    }
    return 3.0;
}
export function resolveTheme(prefs, isSystemDark) {
    return prefs.colors ?? (isSystemDark ? "Dark" : "Light");
}
const textAlignments = {
    Left: TextAlignment.left,
    Right: TextAlignment.right,
    Justify: TextAlignment.justify,
};
/** Deux colonnes dès que le texte dispose de 800 px, jamais plus de deux. */
export const TWO_COLUMNS_MIN_WIDTH = 800;
export function autoColumnsFor(textWidth) {
    return textWidth >= TWO_COLUMNS_MIN_WIDTH ? 2 : 1;
}
export function toEpubPreferences(prefs, isSystemDark, layout = {}) {
    const theme = readingThemes[resolveTheme(prefs, isSystemDark)];
    const a11y = prefs.enableAccessibilityOptions;
    return {
        fontSize: fontSizeStep(prefs.fontSize),
        fontFamily: prefs.fontFamily,
        // Auto (null) : l'hôte fixe une ou deux colonnes selon la largeur du volet (autoColumnsFor).
        columnCount: prefs.columnCount ?? layout.autoColumns ?? null,
        constraint: layout.constraint ?? 0,
        lineHeight: prefs.lineHeight ? lineHeights[prefs.lineHeight] : null,
        textAlign: prefs.textAlign ? textAlignments[prefs.textAlign] : null,
        // Césure appliquée quel que soit l'alignement : en « Auto », la feuille de style du livre ne
        // l'active presque jamais, et le réglage affiché « activé » n'avait alors aucun effet.
        hyphens: prefs.hyphens,
        letterSpacing: a11y ? prefs.letterSpacing : null,
        wordSpacing: a11y ? prefs.wordSpacing : null,
        paragraphSpacing: a11y ? prefs.paragraphSpacing : null,
        ...theme,
    };
}
//# sourceMappingURL=preferences.js.map